import DemoNavbar from "components/Navbars/DemoNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import { routes } from "../../routes/routes";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import { convertirFechaLetra } from "utils/generalFunctions";
import imagenTabernas from "../../assets/avantSolar//HuertasClientes/clientes_tabernas.jpg";
import imagenAlbox from "../../assets/avantSolar//HuertasClientes/clientes_albox.jpg";
import imagenIniesta from "../../assets/avantSolar//HuertasClientes/clientes_iniesta2.jpg";
import imagenVjara from "../../assets/avantSolar//HuertasClientes/clientes_vjara2.jpg";
import imagenVmesia from "../../assets/avantSolar//HuertasClientes/clientes_vmesia3.jpg";
import BarchartInfoCliente from "components/chart/BarChartInfoCliente";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import SpinnerAvantsolar from "components/utils/spinner";
import BarchartProduccionEstimada from "components/chart/BarChartProduccionEstimada";
import { convertirFechaInputFecha } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";
import PerfectScrollbar from "perfect-scrollbar";
import { Helmet } from "react-helmet-async";

const obtenerImagenHuertaId = (id) => {
  switch (id) {
    case 1:
      return imagenTabernas;
    case 2:
      return imagenIniesta;
    case 3:
      return imagenVjara;
    case 4:
      return imagenVmesia;
    case 5:
      return imagenAlbox;
    case 6:
      return null;
    case 7:
      return null;
    case 8:
      return null;
  }
};

var ps;

function ProduccionEstimada(props) {
  const mainPanel = React.useRef();
  const [datosInfo, setDatosInfo] = useState({});
  const [datosTabla, setDatosTabla] = useState(null);
  const [error, setError] = useState(null);
  const params = useParams();
  const { jwt, user } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [loading, setLoading] = useState(false);
  const [minimoFecha, setMinimoFecha] = useState(0);
  const [maximoFecha, setMaximoFecha] = useState(0);
  const [fecha2Activada, setFecha2Activada] = useState(true);
  const [datosGenerales, setDatosGenerales] = useState({
    energiaGenerada: null,
    media: null,
    totalDias: null,
  });

  const fetchInformacionCliente = async (
    fecha_inicio = 20230301,
    fecha_fin = 20230304
  ) => {
    setError(null);
    setLoading(true);

    try {
      const response = await avantSolarApi.get(
        `/all/clientProduction?username=${user?.email}&fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_huerta=${huerta}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);
      if (data?.code == 200) {
        setDatosTabla(data.data.lecturas);
        setDatosInfo(data.data.ultimaLectura);
        let objeto = datosGenerales;
        objeto.totalDias = data.data.totalDias;
        objeto.media = data.data.media;
        objeto.energiaGenerada = data.data.energiaGenerada;

        setDatosGenerales(objeto);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response);
    }
  };

  useEffect(() => {
    fetchInformacionCliente();
  }, []);

  //Al cambiar el valor del select, se vuelve a hacer la petición con el año seleccionado

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let fechaIni = event.target.fechaIni.value.replaceAll("-", "");
    let fechaFin = event.target.fechaFin.value.replaceAll("-", "");

    fetchInformacionCliente(fechaIni, fechaFin);
  };

  const acivarFecha2 = (event) => {
    let fecha = new Date(event.target.value);
    let fechaMax = new Date(event.target.value);
    fechaMax.setDate(fecha.getDate() + 6);

    setMinimoFecha(convertirFechaInputFecha(fecha.toLocaleDateString()));
    setMaximoFecha(convertirFechaInputFecha(fechaMax.toLocaleDateString()));
    setFecha2Activada(false);
  };

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current, {
      suppressScrollX: true, // Disable horizontal scrollbar
    });
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  return (
    <>
      <Helmet>
        <title>Gráfica Producción</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div style={{ height: "99vh" }} className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <div>
            <DemoNavbar {...props} />
            {!error && (
              <Row>
                <Col
                  xs={12}
                  sm={6}
                  md={5}
                  xl={4}
                  className=" p-0 pb-4 fondoColumna"
                >
                  <div className="linea1">
                    <Row>
                      <Col xs={1}>
                        <div className="linea2 h-100 p-3"></div>
                      </Col>
                      <Col>
                        <div className="d-flex justify-content-center flex-column align-items-center p-2">
                          <p className="p-0 m-0 h4 font-weight-bold">
                            ÁREA CLIENTES
                          </p>
                          <p className="p-0 m-0 text-light h6">
                            {datosInfo?.titular} -{" "}
                            {obtenerNombreHuertaId(
                              parseInt(datosInfo?.id_huerta)
                            )}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col xs={12}>
                      <div className="d-flex justify-content-center">
                        <div className=" p-4 bg-white rounded mt-3 w-75">
                          <p>ENERGÍA TOTAL ESTIMADA:</p>

                          <div className="border border-secondary p-3 m-2 ">
                            <p className="text-center">
                              {datosInfo?.eEstimada}{" "}
                              <span className="font-weight-bold">KWh</span>
                            </p>
                          </div>

                          <div className="d-flex justify-content-center">
                            <small className="mb-3 text-center ">
                              Última actualización: {datosInfo?.fechaUltAct}{" "}
                              {datosInfo?.horaUltAct}
                            </small>
                          </div>

                          <p>Última lectura del contador:</p>
                          <p className="mb-3 text-center  d-flex justify-content-around">
                            {datosInfo?.fechaUltimaLectura}{" "}
                            <span>
                              {datosInfo?.ultimaLectura}{" "}
                              <span className="font-weight-bold">KWh</span>
                            </span>
                          </p>
                          <p>Según inversor:</p>
                          <p className="mb-3 text-center d-flex justify-content-around">
                            {datosInfo?.fechaUltimaLectura}{" "}
                            <span>
                              {datosInfo?.energiaMes}{" "}
                              <span className="font-weight-bold">KWh</span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="w-100 mt-5 pl-5 pr-3 d-none d-sm-block">
                    <img
                      draggable="false"
                      width={"100%"}
                      src={obtenerImagenHuertaId(parseInt(datosInfo.id_huerta))}
                    ></img>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={7} xl={8} className="pl-5 pr-5 pt-4">
                  {datosGenerales.media != null && (
                    <p className="text-center ">
                      Generados{" "}
                      <span className="font-weight-bold">
                        {datosGenerales.energiaGenerada}
                      </span>{" "}
                      KWh en{" "}
                      <span className="font-weight-bold">
                        {datosGenerales.totalDias}
                      </span>{" "}
                      días{" ("}
                      <span className="font-weight-bold">
                        {datosGenerales.media}
                      </span>{" "}
                      {" KWh/dia)"}
                    </p>
                  )}
                  {loading && <SpinnerAvantsolar></SpinnerAvantsolar>}
                  {datosTabla && (
                    <>
                      <BarchartProduccionEstimada
                        data2={datosTabla}
                        menuLateral={true}
                      />
                      <form
                        onSubmit={(event) => handleSubmitForm(event)}
                        className="w-100 mt-5"
                      >
                        <Row className="w-100">
                          <Col
                            xs={12}
                            lg={6}
                            className="d-flex justify-content-center  align-items-center mb-3 w-100"
                          >
                            <label className="d-flex flex-column">
                              Fecha Inicio:{" "}
                              <input
                                required
                                onChange={acivarFecha2}
                                name="fechaIni"
                                type="date"
                                defaultValue={"2023-03-01"}
                              />
                            </label>
                          </Col>
                          <Col
                            xs={12}
                            lg={6}
                            className="d-flex justify-content-center align-items-center mb-3 w-100"
                          >
                            <label className="d-flex flex-column">
                              Fecha Fin:{" "}
                              <input
                                required
                                name="fechaFin"
                                min={minimoFecha}
                                max={maximoFecha}
                                disabled={fecha2Activada}
                                type="date"
                                defaultValue={"2023-03-04"}
                              />
                            </label>
                            <button className="btn  btn-primary ml-2">
                              Enviar
                            </button>
                          </Col>
                        </Row>
                      </form>
                    </>
                  )}
                  <div className="p-3">
                    <ul>
                      <li className="mb-3">
                        Los valores de energía de esta gráfica se han obtenido
                        de los inversores, por este motivo puede diferir con las
                        lecturas reales del contador.
                      </li>
                      <li className="mb-3">
                        Si observa algun dia con producción 0, es muy probable
                        que se deba a un fallo del sistema de monitorización del
                        dia en cuestión.
                      </li>
                      <li>
                        Puede notificar cualquier incidencia o consulta en la
                        siguiente dirección de correo electrónico:
                        incidencias@avantsolar.com
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            )}
            {error && <Alert message={error} />}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default ProduccionEstimada;
